// Feature Names
export const FEATURE_NAME_TEST = 'test'
export const FEATURE_NAME_TEST2 = 'test2'

/**
 * Tooltip for auto-play on the end of a video screen
 */
export const FEATURE_NAME_END_STATE_AUTOPLAY_TOOLTIP = 'end-state-autoplay-tooltip'

/**
 * Announcement message for the "ESP" personalization experience
 */
export const FEATURE_NAME_ESP_ANNOUNCEMENT_MODAL = 'esp-announcement-modal'

/**
 * Tooltip on member home screen for settings gear icon
 */
export const FEATURE_NAME_SETTINGS_TOOLTIP = 'settings-tooltip'

/**
 * Tooltip on member home screen for managing a user's series'
 */
export const FEATURE_NAME_MANAGE_SERIES_TOOLTIP = 'manage-series-tooltip'

/**
 * Tooltip on member home screen for editing watch history
 */
export const FEATURE_NAME_WATCH_HISTORY_TOOLTIP = 'watch-history-tooltip'

/**
 * Share v3 button tooltip
 */
export const SHARE_TOOLTIP_MAX_COUNT = 3
